import { render, staticRenderFns } from "./ScanCarDashboard.vue?vue&type=template&id=64e25908"
import script from "./ScanCarDashboard.vue?vue&type=script&lang=js"
export * from "./ScanCarDashboard.vue?vue&type=script&lang=js"
import style0 from "./ScanCarDashboard.vue?vue&type=style&index=0&id=64e25908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports